module.exports = __webpack_public_path__ + "static/teddybikemain-df15a2be6d3a9009803c11c5374025b1.png";